/* eslint camelcase:0 max-statements: 0 */

export default (values) => {
  const errors = {}
  const { target } = values

  if (!target) {
    errors.target = 'target.required'
  }

  if (target <= 0) {
    errors.target = 'target.minlength'
  }

  return errors
}
